import React, { Fragment } from 'react';
import classnames from 'classnames';

import { is768Query } from '~/core/scripts/mediaquery-helper';

const isSmallScreen = !is768Query();

const getRadius = milestone => {
  if (isSmallScreen) {
    return milestone ? 7 : 3;
  }

  return milestone ? 9 : 4;
};

export default ({
  x,
  y,
  active,
  milestone,
  milestoneNumber,
  id,
  onMouseMove,
  epochId
}) => {
  const radius = getRadius(milestone);
  const highlightClasses = classnames('chart__highlight', `epoch-${epochId}`, {
    active
  });
  const onClick = () => {
    const item = document.querySelector(`#item__${id}`);
    window.scrollTo({
      top:
        item.getBoundingClientRect().top +
        window.scrollY -
        window.innerHeight / 3,
      left: 0,
      behavior: 'smooth'
    });
  };

  return (
    <Fragment>
      <circle
        className={highlightClasses}
        r={radius}
        cx={x}
        cy={y}
        onClick={onClick}
        onMouseMove={onMouseMove}
      />
      {milestone && (
        <text
          className={`chart__highlight-number epoch-${epochId}`}
          x={x}
          y={y}
          dy={3.5}
          textAnchor="middle"
        >
          {milestoneNumber}
        </text>
      )}
    </Fragment>
  );
};
